import { Text } from '@mantine/core';
import { FC } from 'react';
import classes from './LabeledField.module.css';
interface LabeledFieldProps {
  label: string;
  value: string | undefined | null;
}

export const LabeledField: FC<LabeledFieldProps> = ({ label, value }) => {
  if (!value) {
    return null;
  }

  return (
    <Text size="xs" c="dimmed" className={classes.text}>
      <Text component="span" fw={500} c="dark">
        {label}:
      </Text>{' '}
      {value}
    </Text>
  );
};
